import {initializePagination} from "../components/pagination";
import {initializeClientIframe} from "../dashboard/components/client-iframe";
import {initializeSortableElements} from "../dashboard/components/sortable";
import {captureException} from "@sentry/browser";
import {initializeMasonry} from "../components/masonry";

require('../components/load');

/**
 * Sending form data using ajax
 *
 * @param element
 * @return boolean
 */
function formAjax(element) {
    let form = new Form(element);
    return form.generateRecaptcha();
}

window.formAjax = formAjax;

window.addEventListener('keydown', function (e) {
    if (e.keyIdentifier === 'U+000A' || e.keyIdentifier === 'Enter' || e.keyCode === 13) {
        if (e.target.nodeName === 'INPUT' && e.target.type === 'text') {
            e.preventDefault();
            return false;
        }
    }
}, true);

class Form {
    /**
     * Constructor of form error
     *
     * @param element
     */
    constructor(element) {
        let self = this;

        self.form = element;
        self.formData = new FormData(self.form[0]);
        self.formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        if (self.formData.get('_method') === null) {
            self.formData.append("_method", self.form.attr('method'));
        }

        if (self.form.data('value') === 'promote') {
            let emails = '';
            window.emailsInput.getValue().forEach(function (email) {
                emails += email + ',';
            });
            self.formData.append('email_list', emails);
        }
    }

    generateRecaptcha(step = null) {
        let self = this;
        self.clearError();
        if ($('meta[name="recaptcha-key"]').length > 0 && $('meta[name="recaptcha-key"]').attr('content').length > 0) {
            grecaptcha.ready(function () {
                grecaptcha.execute($('meta[name="recaptcha-key"]').attr('content'), {action: "submit"}).then(function (token) {
                    self.formData.set('g-recaptcha-response', token);
                    return self.sendRequest(step);
                });
            });
        } else {
            return self.sendRequest(step);
        }
    }

    incrementId() {
        if (!this._id) {
            this._id = 1
        } else {
            this._id++;
        }
    }

    loadingAnimation(showLoading = false) {
        new Load(showLoading);
    }

    /**
     * Display message (Popup)
     *
     * @param title
     * @param type
     * @param message
     */
    displayMessage(title, type, message) {
        let self = this;

        if (typeof toastr !== 'undefined') {
            if (type === 'danger') {
                toastr.error(message, title);
            } else {
                toastr[type](message, title);
            }
        } else {
            try {
                let duration = 2000;
                if (type === 'danger') {
                    duration = null;
                }
                Notification.message(title, message, type, duration);
            } catch (e) {
            }
        }
    }

    /**
     * Send request to server
     *
     * @return boolean
     */
    sendRequest(step = null) {
        let self = this;
        self.clearError();
        self.loadingAnimation(true);

        let method = self.form.attr('method').toUpperCase() === 'GET' ? 'GET' : 'POST'

        let url = self.form.attr('action');
        let async = true;
        let contentType = false;

        if (step) {
            url = $('#step-' + step).data('action');
            method = 'POST';
            async = false;
        }

        let isSuccessful = false;

        $.ajax({
            type: method,
            url: url,
            data: self.formData,
            dataType: 'json',
            async: async,
            cache: false,
            processData: false,
            contentType: contentType,
            success: function (data) {
                let hasTimeout = false;
                if (data.message !== undefined && data.message.length > 0) {
                    if (data.error === false || data.error === undefined) {
                        self.displayMessage('Success', 'success', data.message);
                    } else {
                        self.displayMessage('Error', 'danger', data.message);
                    }
                }
                if (data.redirect !== undefined && data.redirect.length > 0) {
                    hasTimeout = true;
                    setTimeout(function () {
                        window.location.href = data.redirect;
                    }, 2000);
                }


                if (hasTimeout === false) {
                    self.loadingAnimation(false);
                }

                if (data.reload !== undefined && data.reload !== false) {
                    setTimeout(function () {
                        location.reload();
                    }, 500)
                }

                if (data.modal_close !== undefined && data.modal_close !== false) {
                    setTimeout(function () {
                        $('#modal').modal('hide');
                    }, 500)
                }

                if (data.tab_close !== undefined && data.tab_close !== false) {
                    setTimeout(function () {
                        window.close();
                    }, 1000)
                }

                if (data.trigger_cart_render !== undefined && data.trigger_cart_render) {
                    self.renderCart();
                }

                if (data.trigger_render_cart_button !== undefined && data.trigger_render_cart_button) {
                    self.renderCartButton();
                }

                if (data.form_reset && data.form_reset !== false) {
                    self.form[0].reset();
                    try {
                        let editor = tinymce.get('comment');
                        editor.setContent('');
                    } catch (e) {
                    }

                    if (window.dt !== undefined) {
                        window.dt = new DataTransfer();
                    }

                    if ($('#attachment').length > 0) {
                        if ($('#files-area').length > 0) {
                            $('#files-area').html(`<span id="filesList"><span id ="files-names"></span></span>`);
                        }
                    }
                }

                if (data.render_datatable !== undefined && $(".table-datatable-dynamic").length > 0) {
                    setTimeout(function () {
                        $(".table-datatable-dynamic").DataTable()
                            .rows().invalidate('data')
                            .draw(false);
                    }, 500);
                }

                if (data.render_class !== undefined && data.render_class.length > 0) {
                    $(data.render_class).html(data.view);
                } else if (data.closest_class !== undefined && data.closest_class.length > 0) {
                    self.form.closest(data.closest_class).html(data.view);
                } else if (data.append_class !== undefined && data.append_class.length > 0) {
                    $(data.append_class).append(data.view);
                } else if (data.view) {
                    $('#modal').find('.modal-dialog').html(data.view);
                }

                if (data.notification_button_view !== undefined && data.notification_button_view.length > 0) {
                    $('.btn-notification').html(data.notification_button_view);
                }

                if (data.amount !== undefined && data.amount > 0) {
                    $('input[name="amount"]').val(data.amount);
                }

                self.form.find('.post-image-preview').empty();
                self.form.find('.reply-image-preview').empty();

                if (data.scroll_down !== undefined && data.scroll_down) {
                    $('.scrollbar-container').animate({scrollTop: 999999999999999999999});
                }

                if (data.action !== undefined && data.action) {
                    triggerModal(data.action);
                }

                if (data.reload_iframe !== undefined && data.reload_iframe) {
                    $('.iframe-container iframe').attr('src', $('.iframe-container').data('action'));
                    initializeClientIframe();
                    self.renderDiyMenu();
                }

                if (data.input_name !== undefined && data.input_name.length > 0) {
                    $(`input[name='${data.input_name}']`).val(data.input_value);
                }

                try {
                    initializePagination();
                    initializeMasonry();
                } catch (e) {
                }
                isSuccessful = true;
            }, error: function (data) {
                self.displayMessage('Error', 'danger', self.errorMessage(data));
                self.loadingAnimation(false);
                isSuccessful = false;
            }
        });
        return isSuccessful;
    }

    /**
     * This function will generate the error message depending on what Laravel return
     * It will also add the error in the form
     *
     * @param request
     * @returns {string}
     */
    errorMessage(request) {
        // Parser the json response expected
        try {
            if (request === undefined || request.responseText === undefined) {
                return 'An error occurred, please try again.';
            }
            let response = JSON.parse(request.responseText);
            let self = this;
            let errorString = "";
            let field;
            let alreadyScrolled = false;

            //Initialize the error
            $('.invalid-feedback').remove();
            $('.is-invalid').removeClass('is-invalid');

            // Validation error would return 422 header
            if (request.status === 422) {
                errorString += `<ul>`;
                $.each(response.errors, function (k, value) {
                    let element, key;
                    if (k.includes('.')) {
                        k.split('.').forEach(function (item, index) {
                            if (index === 0) {
                                field = item;
                            } else {
                                field += `[${item}]`;
                            }
                        });
                        key = `[name='${field}']`;
                        element = self.form.find(key);
                        let element2 = self.form.find(`[name = '${field}[]']`);
                        let element3 = self.form.find(`[name = '${field}']`);

                        if (element2.length > 0) {
                            element = element2;
                        } else if (element3.length > 0) {
                            element = element3;
                        }
                    } else {
                        key = `[name='${k}']`;
                        element = self.form.find(key);
                        if (element.data('field-id') !== undefined && element.data('field-id').length > 0) {
                            element = $(`#${element.data('field-id')}`);
                        }
                    }

                    if (element !== undefined && element.length > 0 && alreadyScrolled === false) {
                        alreadyScrolled = true;
                        $([document.documentElement, document.body]).animate({
                            scrollTop: element.offset().top - 200
                        });
                    }

                    try {
                        value = value.join(' ');
                    } catch (e) {
                    }

                    if (element.is(':checkbox') || element.is(':radio')) {
                        element.parent().append(`<div class="invalid-feedback" style="display: block">${value}</div>`);
                    } else {
                        if (element.closest('.input-group').length > 0) {
                            element.closest('.input-group').after(`<div class="invalid-feedback" style="display: block">${value}</div>`);
                        } else {
                            if (element.is('.text-editor')) {
                                let textEditorField = element.parent().find('.tox-tinymce');
                                textEditorField.css('border-color', '#d92550');
                                textEditorField.after(`<div class="invalid-feedback">${value}</div>`);
                            } else {
                                element.after(`<div class="invalid-feedback">${value}</div>`);
                            }
                        }
                    }
                    element.addClass('is-invalid');
                    errorString += `<li>${value}</li>`;
                });

                $.each(response.success, function (key, value) {
                    let element = self.form.find(`[name='${key}']`);
                    //Adding the success to the input field
                    if (element.is(':radio')) {
                        element = self.form.find(`input[name='${key}']:checked`)
                    } else {
                        if (!element) {
                            element = self.form.find(`[name='${key}[]']`)
                        }
                        element.after(`<div class="valid-feedback">${value}</div>`);
                    }
                    element.addClass('is-valid');
                });
                errorString += '</ul>';
            } else {
                errorString += `<ul><li>${response.message}</li></ul>`;
            }

            return errorString;
        } catch (e) {
            captureException(e);
            return 'An error occurred, please try again. ' + e.message;
        }
    }

    /**
     * Remove error class
     */
    clearError() {
        $('.invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');
        $('.toast-dynamic').html('');
    }

    /**
     * Render cart button
     */
    renderCartButton() {
        let self = this;
        $('.cart-button-container').each(function () {
            let self = $(this);
            let action = self.data('render');
            $.ajax({
                type: 'GET',
                url: action,
                async: false,
                cache: false,
                success: function (data) {
                    self.html(data.view);
                    $('.cart-button-container').html(data.view)
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }

    /**
     * Trigger the render cart event
     */
    renderCart() {
        let self = this;
        $('.cart-container').each(function () {
            let self = $(this);
            let action = self.data('render');
            $.ajax({
                type: 'GET',
                url: action,
                async: false,
                cache: false,
                data: {
                    'country': $('select[name="country"]').val(),
                    'state': $('select[name="state"]').val(),
                },
                success: function (data) {
                    self.html(data.view);
                    $('.cart-summary-container').html(data.view_summary)
                    if (data.reload !== undefined && data.reload) {
                        setTimeout(function () {
                            location.reload();
                        }, 500)
                    }

                    if (data.amount !== undefined && data.amount > 0) {
                        $('input[name="amount"]').val(data.amount);
                    }

                    if (data.redirect !== undefined && data.redirect.length > 0) {
                        setTimeout(function () {
                            window.location.href = data.redirect;
                        }, 2000);
                    }
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }

    /**
     * Trigger the render cart event
     */
    renderDiyMenu() {
        let self = this;
        $('.preview-container').each(function () {
            let self = $(this);
            let action = self.data('action');

            $.ajax({
                type: 'GET',
                url: action,
                async: true,
                cache: false,
                success: function (data) {
                    self.html(data.view);
                    initializeSortableElements();
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }
}

export default Form;

